import BlockTitle from '@/components/block_title';
import Picture from '@/components/picture';


export default {

	props: {
		title: {
			type: String,
		},

		width: {
			type: String,
		},

		/** 高亮长度 */
		highlight_length: {
			type: Number,
			default: 0,
		},
	},


	computed: {
		highlight_index: (vm) => {
			return vm.highlight_length > 0
				? vm.highlight_length
				: 0
			;
		},
	},


	components: {
		'c-block-title': BlockTitle,
		'c-picture': Picture,
	},

};
